import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-connection-error',
  templateUrl: './connection-error.component.html',
  styleUrls: ['./connection-error.component.css'],
  standalone: false,
})
export class ConnectionErrorComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  LinktoPage(page) {
    this.router.navigate([page]);
  }
}
